<template>
    <modal name="mdl-gerar-link-rillpay" @opened="mtdinicializaselect" @before-close="zeratudo" height="auto" width="800" :adaptive="true" :scrollable="true">
        <div class="modal-header">
            <h6 class="modal-title" style="font-size: 16px;"><img src="/icone-rpay-white.svg" style="width: 30px; height: 25px; opacity: .5; margin-right: 5px;" alt="icone rillpay"> Gerar link de compartilhamento RillPay</h6>
            <button type="button" class="close" @click.prevente="$modal.hide('mdl-gerar-link-rillpay')">&times;</button>
        </div>
        <div class="modal-body">
            <div class="container">
                <div class="row mt-2">
                    <div class="col-sm-12 col-md-8 col-lg-8">
                        <span class="lblselect2">Cliente:</span>
                        <select title="Cliente" id="cbclientepesqrp" data-placeholder="Selecione um cliente" 
                            data-allow-clear="true"
                            style="width:100%;" 
                            v-model="vidcliente">
                        </select>
                    </div>
                    <div class="col-sm-12 col-md-4 col-lg-4">
                        <span class="lblselect2">Filial:</span>
                        <select id="cbfilialrp" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                style="width:100%;" v-model="vidfilial">
                        </select>
                    </div> 
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="input-group is-invalid">
                            <input id="edlinkrp" type="text" class="form-control form-control-sm" @click.prevent="mtdCopiarLinkRillpay()" v-model="urlRPGerada" style="cursor: pointer;" readonly>
                            <div class="input-group-prepend">
                                <div class="input-group-text" @click.prevent="mtdAbrirLinkRillpay()" style="color: #fff; background-color: #6f7f8c; border-color: #6f7f8c; border-top-right-radius: 9px; border-bottom-right-radius: 9px; cursor: pointer"><i class="fa fa-external-link" aria-hidden="true"></i></div>
                            </div>
                        </div>
                        <small id="urlHelp" class="form-text text-muted">
                            <i class="fa-solid fa-circle-info"></i> Clique no link para copiar.
                        </small>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12">
                        <div style="max-height: 350px; overflow-y: auto;">
                            <vue-bootstrap4-table ref="refdestaquesprodutos"
                                :rows="lstTitulosCliente"
                                :columns="columns"
                                :config="config"
                                :classes="classes">
                            <template slot="empty-results">
                                <div class="col-md-12 text-center">Não há títulos disponíveis para visualização</div>
                            </template>
                            <!-- ícones de ordenação da table -->
                            <template slot="sort-asc-icon">
                                <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                            </template>
                            <template slot="sort-desc-icon">
                                <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                            </template>
                            <template slot="no-sort-icon">
                                <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                            </template>
                        </vue-bootstrap4-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" @click.prevent="$modal.hide('mdl-gerar-link-rillpay')" style="width: 100px;">Fechar <i class="fa fa-sign-out"></i></button>
        </div>
    </modal>
</template>
<script>
import util from '../utilitarios/util.js'
import VueBootstrap4Table from 'vue-bootstrap4-table'
export default {
    name: 'cmpgeralinkrillpay',
    components: {
        VueBootstrap4Table,
    },
    props:{
        // Mandar caso queira uma filial específica, se não, irá selecionar a filial padrão do usu.
        codfil: { 
            default: null
        }, 
        descfil: {
            default: ''
        },
        // Mandar caso queira um cliente específico, se não, será definido como null.
        idcliente: {
            default: null
        }, 
        // Só terá efeito caso envie o idcliente.
        nomecliente: {
            default: ''
        } ,
    },
    data: function() {
        return {
            vidfilial                   : 0,
            vdescfilial                 : '',

            vidcliente                  : 0,
            vnomecliente                : '',

            cnpjCpfCliente              : '',
            chaveAcessoCliente          : '',
            lstTitulosCliente           : [],

            columns: [
                {
                    label: "Nr. Título",
                    name: "codtit",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-codtit"
                },                                       
                {
                    label: "Emissão",
                    name: "dtemitit",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-datas"
                },
                {
                    label: "Vencimento",
                    name: "dtventit",
                    sort: true,
                    row_text_alignment: "text-left",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-datas"
                },
                {
                    label: "Juros",
                    name: "vljuros",
                    sort: true,
                    slot_name: "slot_vljuros",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-valores"
                },                                                              
                {
                    label: "Multa",
                    name: "vlmulta",
                    sort: true,
                    slot_name: "slot_vlmulta",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-valores"
                },
                {
                    label: "Vl. total",
                    name: "vlresta",
                    sort: true,
                    slot_name: "slot_vlresta",
                    row_text_alignment: "text-right",
                    column_text_alignment: "text-left",                        
                    row_classes: "def-col-valores"
                },         
            ],
            config: {
                pagination: false,
                pagination_info: false,
                card_mode: false,
                checkbox_rows: false,
                //rows_selectable: true,
                global_search: {
                    visibility: false,
                },
                show_refresh_button : false,
                show_reset_button : false
            },
            
            classes: {
                table: "table-bordered table-striped table-sm"
            }
        };
    },
    methods: {
        mtdinicializaselect(){
            let vself = this;

            vself.vidfilial     = this.codfil ? this.codfil : this.$store.state.filialpadrao.codfil;
            vself.vdescfilial   = this.descfil ? this.descfil : this.$store.state.filialpadrao.fantasia;
            vself.vidcliente    = this.idcliente ? this.idcliente : 0;
            vself.vnomecliente  = this.nomecliente ? this.nomecliente : '';

            $("#cbclientepesqrp").select2({
                id: function (e) {return e.id},
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbclientes',
                            c1: 'id',
                            c2: 'nome'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 1,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidcliente = $("#cbclientepesqrp").val();
                vself.vnomecliente = $("#cbclientepesqrp").text();
                vself.buscaDadosLink();
            });

            if (parseInt(this.vidcliente) > 0) {
                var defcli = new Option(`${vself.vidcliente} - ${vself.vnomecliente}`, vself.vidcliente, true, true);
                $('#cbclientepesqrp').append(defcli).trigger('change');
            } else {
                $("#cbclientepesqrp").val(null).trigger('change');
            }

            $("#cbfilialrp").select2({
                id: function (e) {return e.id},
                ajax: {
                    url: vself.$store.state.configpaths.pathselect2,
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            tb: 'tbfiliais',
                            c1: 'codfil',
                            c2: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidfilial = $("#cbfilialrp").val();
                vself.vdescfilial = $("#cbfilialrp").text();
                vself.buscaDadosLink();
            });
            
            var deffilial = new Option(vself.vdescfilial, vself.vidfilial, true, true);
            $('#cbfilialrp').append(deffilial).trigger('change');
        },
        zeratudo(){
            this.vidfilial              = 0;
            this.vdescfilial            = '';
            this.vidcliente             = 0;
            this.vnomecliente           = '';

            this.cnpjCpfCliente         = '';
            this.chaveAcessoCliente     = '';
            this.lstTitulosCliente      = [];

            $("#cbclientepesqrp").val(null).trigger('change');
            $("#cbfilialrp").val(null).trigger('change');
        },
        buscaDadosLink(){
            let vself = this;

            let loader = vself.$loading.show();
            let parametros = [
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'buscadadoslink'},
                {parametro: 'idfilial',     valor : vself.vidfilial},
                {parametro: 'idcliente',    valor : vself.vidcliente}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                // se tiver cnpj, cria a string do parametro no link
                vself.cnpjCpfCliente        = response.data.cnpjcpf;
                vself.chaveAcessoCliente    = response.data.chaveacesso;
                vself.lstTitulosCliente     = response.data.titulos;
            }).catch(function (error) {
                loader.hide();
                vself.$toastr.e('Erro ao buscar dados para o link.', 'Erro!');
                console.log(error);
            });  
        },
        mtdCopiarLinkRillpay(){
            let vself = this;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(this.urlRPGerada)
                    .then(() => {
                        vself.$toastr.s('Link copiado com sucesso!', 'Informação!'); 
                    })
                    .catch(err => {
                        vself.$toastr.e('Erro ao copiar o link.', 'Erro!');
                    });
            } else {
                // método alternativo
                let input = document.createElement('input');
                input.setAttribute('value', this.urlRPGerada);
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                vself.$toastr.s('Link copiado com sucesso!', 'Informação!');
            }
        },
        mtdAbrirLinkRillpay(){
            if (this.urlRPGerada) {
                window.open(this.urlRPGerada, '_blank');
            }
        }
    },
    mounted: function() {

    },    
    computed:{ 
        urlRPGerada() {
            let url = 'https://rillpay.nacional-app.com.br'; // Base URL

            if (this.vidfilial) {
                url += `/filial/${this.vidfilial}/acessar`;
            } else {
                url += '/acessar'; 
            }

            let parametros = [];

            if (this.cnpjCpfCliente) {
                parametros.push(`cnpjcpf=${this.cnpjCpfCliente}`);
            }

            if (this.chaveAcessoCliente) {
                parametros.push(`acesso=${this.chaveAcessoCliente}`);
            }

            if (parametros.length > 0) {
                url += '?' + parametros.join('&');
            }

            return url;
        }
    },
    watch: {
    }
}
</script>
<style>
    .def-col-codtit{
        width: 120px !important;
    }
</style>